import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const miro = defineConnector({
  identifier: "miro",
  name: "Miro",
  tagLine: "Visual collaboration platform",
  keywords:
    "whiteboard boards diagramming sticky notes brainstorming realtimeboard",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.miro\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Miro app",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [Miro Developer Portal](https://miro.com/app/settings/user-profile/apps) and create a new app, or select an existing one.",
        },
      ],
    },
    {
      title: "Configure OAuth redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your Miro app settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/miro/callback",
        },
      ],
    },
    {
      title: "Get your app credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Copy the Client ID and Client secret from your Miro app settings.",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Define scopes",
      items: [
        {
          kind: "markdown",
          content:
            "Add [scopes](https://developers.miro.com/reference/scopes) in a space separated list below. Common scopes include `boards:read boards:write`.",
        },
        {
          kind: "input",
          label: "Scopes (optional)",
          placeholder: "boards:read boards:write",
          helperText: "Space separated list of desired scopes.",
          target: { kind: "oauthConnection", field: "scopes" },
        },
      ],
    },
    {
      title: "Authorize your Miro account",
      items: [
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://miro.com/oauth/authorize",
    tokenEndpoint: () => "https://api.miro.com/v1/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.miro.com/v2/boards",
  },
});
